export const beforeUnload = e => {
  e.preventDefault();
  e.returnValue = true;
};
